import React, { createContext, useContext } from 'react';
import T from 'prop-types';

import { useBreakpoints } from '../../hooks/useBreakpoints';

const BreakpointsCtx = createContext(null);

const BreakpointsProvider = ({ children }) => {
  const breakpoint = useBreakpoints();

  const screens = {
    isScreenMinXs: ['xs', 'sm', 'md', 'lg', 'xl'].includes(breakpoint),
    isScreenMinSm: ['sm', 'md', 'lg', 'xl'].includes(breakpoint),
    isScreenMinMd: ['md', 'lg', 'xl'].includes(breakpoint),
    isScreenMinLg: ['lg', 'xl'].includes(breakpoint),
    isScreenMinXl: ['xl'].includes(breakpoint),
  };

  return <BreakpointsCtx.Provider value={{ breakpoint, ...screens }}>{children}</BreakpointsCtx.Provider>;
};

BreakpointsProvider.propTypes = {
  children: T.node.isRequired,
};

export default BreakpointsProvider;

export const useBreakpointsCtx = () => useContext(BreakpointsCtx);
